import Api from './baseApi';

export default {
  searchRichOrders: (searchDto) => {
    return Api.post('/api/RichOrders/search', searchDto);
  },

  lockOrder: (orderNumber) => {
    return Api.post(`/api/RichOrders/lock/${orderNumber}`);
  },

  unlockOrder: (orderNumber) => {
    return Api.post(`/api/RichOrders/unlock/${orderNumber}`);
  },

  getActivePartnerBanks: () => {
    return Api.get('/api/partnerbanks/all');
  },

  updateOrderStatus: (orderId, status) => {
    return Api.post(`/api/RichOrders/updateStatus/${orderId}`, { status });
  },

  completeBulkOrder: (poolOrders) => {
    // E-Altın için özel endpoint (CompletedDate + Banka altın düşme)
    return Api.post('/api/RichOrders/bulkInsertForEAltin', poolOrders);
  },

  updateOrderItemIban: (orderItemId, newIban) => {
    return Api.post(`/api/RichOrders/updateOrderItemIban/${orderItemId}`, {
      newIban,
    });
  },

  updateOrderItemNotes: (orderItemId, notes) => {
    return Api.post(`/api/RichOrders/updateOrderItemNotes/${orderItemId}`, {
      notes,
    });
  },

  getFraudOrders: () => {
    return Api.get('/api/RichOrders/fraud-orders');
  },

  markFraudSent: (orderNumbers) => {
    return Api.post('/api/RichOrders/mark-fraud-sent', { orderNumbers });
  },

  clearFraudFlag: (orderNumber) => {
    return Api.post(`/api/RichOrders/clear-fraud-flag/${orderNumber}`);
  },

  getCompletedOrdersForExport: (startDate, endDate) => {
    return Api.get('/api/RichOrders/completed-orders-export', {
      params: { startDate, endDate },
    });
  },

  getNewOrdersBankSummary: (startDate, endDate) => {
    return Api.get('/api/RichOrders/new-orders-bank-summary', {
      params: { startDate, endDate },
    });
  },

  getCompletedOrdersBankSummary: (date) => {
    return Api.get('/api/RichOrders/completed-orders-bank-summary', {
      params: { date },
    });
  },

  setReferenceNo: (orderNumber, referenceNo) => {
    return Api.post(`/api/RichOrders/set-reference/${orderNumber}`, { referenceNo });
  },

  removeReceipt: (orderNumber, fileKey) => {
    return Api.post(`/api/RichOrders/remove-receipt/${orderNumber}`, { fileKey });
  },

  removeIdentityPhoto: (orderNumber, photoType, userConfirmed) => {
    return Api.post(`/api/RichOrders/remove-identity-photo/${orderNumber}`, {
      photoType,
      userConfirmed,
    });
  },

  getEaltinOrderListExcel: (date) => {
    return Api.get('/api/RichOrders/ea-order-list-excel', {
      params: { date },
    });
  },

  getAltindafirsatOrderListExcel: (date) => {
    return Api.get('/api/RichOrders/altindafirsat-order-list-excel', {
      params: { date },
    });
  },

  getEaltinNewOrdersExpectedTotal: () => {
    return Api.get('/api/RichOrders/ea-new-orders-expected-total');
  },

  getAltindafirsatNewOrdersExpectedTotal: () => {
    return Api.get('/api/RichOrders/altindafirsat-new-orders-expected-total');
  },

  addCustomerToBlacklist: (email) => {
    return Api.post('/api/RichOrders/blacklist/add', { email });
  },

  removeCustomerFromBlacklist: (email) => {
    return Api.post('/api/RichOrders/blacklist/remove', { email });
  },

  getBlacklistedCustomers: () => {
    return Api.get('/api/RichOrders/blacklist/list');
  },

  addCustomerToUserFraud: (email) => {
    return Api.post('/api/RichOrders/user-fraud/add', { email });
  },

  removeCustomerFromUserFraud: (email) => {
    return Api.post('/api/RichOrders/user-fraud/remove', { email });
  },

  getUserFraudCustomers: () => {
    return Api.get('/api/RichOrders/user-fraud/list');
  },
};
